<template>
    <div class="item-root p-2">
        <div class="d-flex align-items-center justify-content-center">
            <FlagIcon :country="code" size="big" />
        </div>

        <div>
            <h6 class="title bold mb-1 mt-2">{{ countryName }}</h6>
            <h6 v-if="implicit" class="caption gray-color">
                {{ $t('spotlight.workAuthorization.implicitValue') }}
            </h6>
        </div>

        <IconBtn v-if="!implicit" class="m-auto" name="trash" color="secondary" @click="onDelete" />
    </div>
</template>

<script>
import countries from 'highered-utils/data/countries.json';
export default {
    name: 'WorkAuthorizationItem',
    props: {
        type: {
            type: Number,
            default: 0,
        },
        code: {
            type: String,
            default: 'ZZ',
        },
        implicit: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        countryName() {
            if (this.type === 0) {
                const country = countries.find(c => c.value === this.code);
                if (country !== undefined) {
                    return country.label;
                } else {
                    return '';
                }
            } else {
                if (this.code === 'EU') {
                    return 'EU';
                } else {
                    return '';
                }
            }
        },
        flag() {
            if (this.type === 0) {
                const country = countries.find(c => c.value === this.code);
                if (country !== undefined) {
                    return country.label;
                } else {
                    return '';
                }
            } else {
                if (this.code === 'EU') {
                    return 'EU';
                } else {
                    return '';
                }
            }
        },
    },
    methods: {
        onDelete() {
            this.$emit('onDelete', this.code);
        },
    },
};
</script>

<style scoped>
.item-root {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 2px;

    display: grid;
    grid-template-columns: 80px auto 38px;
    grid-gap: 16px;
}

@media only screen and (max-width: 600px) {
    .item-root {
        grid-template-columns: auto;
        justify-content: center;
        text-align: center;
    }
}
</style>
